import { menuFirsts } from "../../constants/menu"
import Repair from "../../pages/repair/repair"
import AddRepair from "../../pages/repair/add/addRepair"
import { routeName } from "../routers-name"
import RepairAgentList from "../../pages/repair/repairListAgent"
import RepairByAgent from "../../pages/repair/repairByAgent"
const routeRepair = [
    {
      ...menuFirsts.REPAIR,
      key: menuFirsts.REPAIR.key,
      name: menuFirsts.REPAIR.name,
      textName: menuFirsts.REPAIR.textName,
      active: false,
      appBar: true,
      component: Repair
    } ,
    {
      ...menuFirsts.REPAIR,
      key: menuFirsts.REPAIR.key,
      name: menuFirsts.REPAIR.name,
      textName: menuFirsts.REPAIR.textName,
      path: routeName.repair + "/add-repair",
      active: false,
      appBar: true,
      component: AddRepair
    },
         {
          path: routeName.repair + '-list-agent',
          active: false,
          appBar: true,
          component: RepairAgentList
        },
        {
          ...menuFirsts.REPAIR,
          key: menuFirsts.REPAIR.key,
          name: menuFirsts.REPAIR.name,
          textName: menuFirsts.REPAIR.textName,
          path: routeName.repair + '-by-agent/:id',
          active: false,
          appBar: true,
          component: RepairByAgent
        },
  ]
  
  export default routeRepair